import { SecurityType } from '~/types'

export const securityTypeLabels: Record<SecurityType, string> = {
  [SecurityType.CASH]: 'Cash',
  [SecurityType.FINANCE]: 'Finance',
  [SecurityType.PROPERTY]: 'Property',
  [SecurityType.OTHER]: 'Other'
}

export const securityTypeOptions = Object.values(SecurityType).map(value => ({
  value,
  label: securityTypeLabels[value]
}))
